import type {
  ClauseSelection,
  Confidence,
  DetectedField,
  DetectionResponse,
  FlaggedValue,
} from '../models/ai-template-builder.model';
import type {
  WireClauseSelection,
  WireConfidence,
  WireDetectedField,
  WireDetection,
  WireFlaggedValue,
} from '../models/detection-wire.model';

// One number inside each band of the thresholds in detection-derivations.helper.ts.
const CONFIDENCE: Record<WireConfidence, Confidence> = { high: 0.9, medium: 0.7, low: 0.4 };

function adaptField({ confidence, ...field }: WireDetectedField): DetectedField {
  return { ...field, confidence: CONFIDENCE[confidence] };
}

function adaptFlaggedValue({ confidence, ...flaggedValue }: WireFlaggedValue): FlaggedValue {
  return { ...flaggedValue, confidence: CONFIDENCE[confidence] };
}

function adaptClauseSelection({ suggestedVariable, ...clauseSelection }: WireClauseSelection): ClauseSelection {
  if (!suggestedVariable) {
    return clauseSelection;
  }

  const { name, label, category } = suggestedVariable;

  return { ...clauseSelection, proposedVariable: { name, label, category } };
}

/** Reads the backend's detection into the shapes the builder works on. */
export function adaptDetection({
  status,
  errorCode,
  activity,
  detectionResult: data,
}: WireDetection): DetectionResponse {
  if (!data) {
    return { status, errorCode, activity };
  }

  return {
    status,
    errorCode,
    activity,
    data: {
      document: data.document,
      fields: data.fields.map(adaptField),
      clauseSelections: data.clauseSelections.map(adaptClauseSelection),
      flaggedValues: data.flaggedValues.map(adaptFlaggedValue),
      referenceDataBlocks: data.referenceDataBlocks,
      notices: data.notices,
    },
  };
}
